import { asyncLoad } from '@util'

export default {
  path: 'brand',
  indexRoute: {
    component: asyncLoad(() => import('@components/LocalMerchant/Brand'))
  },
  stat: '品牌页配置'
}
